import { useQuery } from '@tanstack/react-query'
import notificationService from '../../service'
import { notificationQueryKeys } from '../keys/notification.query-keys'

export const useHasUnread = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: notificationQueryKeys.hasUnread(),
    queryFn: notificationService.getHasUnread,
    select: (res) => res.object ?? false,
    enabled,
  })
